<template>
  <v-btn-toggle class="brand-btn-toggle" v-bind="mergedAttrs">
    <template v-for="(_, slotName) in $slots" :key="slotName" #[slotName]="slotData">
      <slot :name="slotName" v-bind="slotData || {}" />
    </template>
  </v-btn-toggle>
</template>

<script setup>
import { computed, useAttrs } from 'vue'
import { mergeAttrs } from '@/utils/vue-attrs'

const props = defineProps({
  variant: { type: String, default: 'basic' },
})

const attrs = useAttrs()

const VARIANTS = {
  basic: { mandatory: true, density: 'comfortable', classes: ['brand-btn-toggle--basic'] },
}

const commonAttrs = computed(() => {
  const variant = VARIANTS[props.variant]
  return {
    'hide-details': 'auto',
    ...variant,
    class: [...(variant?.classes ?? [])],
  }
})

const mergedAttrs = computed(() => mergeAttrs(commonAttrs.value, attrs))

defineOptions({ inheritAttrs: false })
</script>

<script>
export default { inheritAttrs: false }
</script>

<style lang="scss">
.brand-btn-toggle.brand-btn-toggle--basic {
  width: 100%;
  height: auto;
  border: 1px solid rgb(var(--v-theme-neutral50));
  border-radius: 8px;
  padding: 4.4px;
  gap: 4px;

  .v-btn {
    flex: 1 1 0;
    border-radius: 6px !important;
    border: none !important;
    text-transform: none;
    letter-spacing: 0.03125em;
    color: rgb(var(--v-theme-neutral600));
    // +10% taller options: extra top/bottom breathing room around each label
    // (size="large" is ~44px; bump to ~48px) so the bookmark/note switch on the
    // share screen isn't cramped.
    min-height: 48px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // selected segment
  .v-btn.v-btn--active {
    background-color: rgb(var(--v-theme-neutral0)) !important;
    color: rgb(var(--v-theme-neutral900)) !important;
    box-shadow: 0 1px 2px rgba(0, 53, 76, 0.16);
  }
}
</style>
